/*
 *		 Hauptnavi Dropdowns > Suche
 */

window.addEventListener('DOMContentLoaded', () => {

	const dropdowns = document.querySelectorAll('ul.c-nav__dropdown.has_searchbox');

	dropdowns.forEach(dropdown => {
		const searchbox = dropdown.querySelector('.searchbox');
		const input = searchbox.querySelector('input[type="text"]');
		const items = dropdown.querySelectorAll('li:not(.searchbox)');
		const itemsArray = Array.from(items);

		input.addEventListener('input', () => {
			const value = input.value.toLowerCase();

			itemsArray.forEach(item => {
				const text = item.textContent.toLowerCase();

				if (text.includes(value)) {
					item.style.display = 'block';
				} else {
					item.style.display = 'none';
				}
			});
		});
	});

});